export default __webpack_public_path__ + "static/media/video5.73a668c8.webp";